import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sendlane-details-modal',
  templateUrl: './sendlane-details-modal.component.html',
  styleUrls: ['./sendlane-details-modal.component.scss']
})
export class SendlaneDetailsModalComponent {
  @Input() item: any;
  @Input() details: {
    payload: string;
    response: string;
  };

  constructor(public activeModal: NgbActiveModal) {}

  formatJSON(json: any): string {
    if (!json) return '';
    
    try {
      if (typeof json === 'string') {
        json = JSON.parse(json);
      }
      
      const formatted = JSON.stringify(json, null, 2)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
          let cls = 'json-number';
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'json-key';
            } else {
              cls = 'json-string';
            }
          } else if (/true|false/.test(match)) {
            cls = 'json-boolean';
          } else if (/null/.test(match)) {
            cls = 'json-null';
          }
          return `<span class="${cls}">${match}</span>`;
        });

      return formatted;
    } catch (e) {
      console.error('Error formatting JSON:', e);
      return String(json);
    }
  }
} 